// src/app/core/mainPage/prompt/prompt-composer/components/PromptComposer.tsx
import type { KeyboardEvent } from "react";
import { Send } from "lucide-react";
import type { PromptComposerViewProps } from "../types";
import { useTranslation } from '@/app/core/ui/theme/LanguageProvider';



export function PromptComposer({ prompt, textareaRef, onPromptChange, onSubmit }: PromptComposerViewProps) {
  const { t } = useTranslation();

  const handleKeyDown = (event: KeyboardEvent<HTMLTextAreaElement>) => {
    if (event.key === "Enter" && (event.metaKey || event.ctrlKey)) {
      event.preventDefault();
      onSubmit();
    }
  };

  

  return (
    <div
      className="rounded-[28px] p-[1px] shadow-[0_18px_50px_rgba(99,102,241,0.15)]"
      style={{ background: "linear-gradient(135deg, #8b5cf6, #6366f1)" }}
    >
      <div className="rounded-[27px] p-4 bg-background">
        <textarea
          ref={textareaRef}
          value={prompt}
          onChange={(event) => onPromptChange(event.target.value)}
          onKeyDown={handleKeyDown}
          rows={3}
          placeholder={t('promptPlaceholder')}
          className="w-full resize-none border-0 bg-transparent text-[15px] leading-6 outline-none text-foreground placeholder:text-muted-foreground"
          style={{ minHeight: "88px", maxHeight: "220px" }}
        />
        <div className="mt-3 flex items-center justify-between gap-3">
          <p className="text-xs text-muted-foreground">{t('shortcutHint')}</p>
          <button
            type="button"
            onClick={onSubmit}
            disabled={!prompt.trim()}
            className="inline-flex items-center gap-2 rounded-2xl px-5 py-3 text-sm font-semibold text-white transition disabled:cursor-not-allowed disabled:opacity-50"
            style={{
              background: prompt.trim()
                ? "linear-gradient(135deg, #8b5cf6, #6366f1)"
                : "var(--muted)",
              color: prompt.trim() ? "#fff" : "var(--muted-foreground)"
            }}
          >
            <Send className="h-4 w-4" />
            {t('create')}
          </button>
        </div>
      </div>
    </div>
  );
}